/**
 my_download data store
 */
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export const my_download_store = {
    namespaced: true,
    state: {
        clickFrom: "top",
        hasNewNotification: false,
        total_size: 0, //資源的總大小
        total_select: 0, //選擇了多少個資源
        resource_list: [], //選擇了資源的列表
        zip_list: [], //總共有多少個zip
        expired_list: [],
        load_more: 0,
        skip: 0
    },
    mutations: {
        newNotification(state) {
            state.hasNewNotification = true;
        },
        offNotification(state) {
            state.hasNewNotification = false;
        },
        updateData(state, record) {

            var arr_resource = [];
            if (record.resource_list) {
                record.resource_list.forEach(function(resource) {
                    arr_resource[resource.id] = resource.id
                });
            }

            state.total_size = record.total_size;
            state.total_select = record.total_select;
            state.resource_list = record.resource_list;
            state.expired_list = record.expired_list;
            state.load_more = record.load_more;
            state.skip = record.skip;

            //如果有pack新的zip 才更新zip list
            if (record.zip_list) {
                state.zip_list = record.zip_list;
            }
        },
        setLoadMoreData(state, record)
        {
            state.load_more = record.load_more;
            state.skip = record.skip;

            if (record.expired_list) {
                record.expired_list.forEach(function (item) {
                    state.expired_list.push(item);
                });
            }
        }
    },
    getters: {

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/my_download.js